import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { ThemeContext } from "~/utils";
import { HighlightWithinTextarea } from "react-highlight-within-textarea";

interface StateProps {
  authenticatedUser: any;
}

interface DispatchProps {}

interface OwnProps {
  autoComplete?: string;
  className?: string;
  disabled?: boolean;
  id?: string;
  maxLength?: number;
  name?: string;
  onBlur?: any;
  onChange?: any;
  onClick?: any;
  onFocus?: any;
  placeholder?: string;
  value?: string;
  getRanges: any;
  rows: number;
}

type Props = StateProps & DispatchProps & OwnProps;

type State = {
  focus: boolean;
};

const mapStateToProps = (state: any) => ({
  authenticatedUser: state.users.authenticatedUser,
});

class ThemedHighlitedTextarea extends PureComponent<Props, State> {
  state = {
    focus: false,
  };

  handleFocus = () => {
    this.setState({ focus: true }, () => {
      if (this.props.onFocus) this.props.onFocus();
    });
  };

  handleBlur = () => {
    this.setState({ focus: false }, () => {
      if (this.props.onBlur) this.props.onBlur();
    });
  };

  handleKeyDown(e: any) {
    e.target.style.height = "inherit";
    e.target.style.height = `${e.target.scrollHeight}px`;
    // In case you have a limitation
    // e.target.style.height = `${Math.min(e.target.scrollHeight, limit)}px`;
  }
  render() {
    let brandColor;
    const { authenticatedUser: user } = this.props;
    if (
      this.context.theme ||
      (user && user.company && user.company.whitelabeling)
    ) {
      const theme = this.context.theme;
      brandColor =
        theme === "default"
          ? user.company.whitelabeling.primary_css_color
          : theme;
    }
    return (
      <HighlightWithinTextarea
        highlight={this.props.getRanges}
        autoComplete={this.props.autoComplete}
        className={this.props.className || "input"}
        disabled={this.props.disabled}
        id={this.props.id}
        maxLength={this.props.maxLength}
        name={this.props.name}
        onClick={this.props.onClick}
        onChange={this.props.onChange}
        onBlur={this.handleBlur}
        onFocus={this.handleFocus}
        placeholder={this.props.placeholder}
        style={
          brandColor && this.state.focus ? { borderColor: brandColor } : {}
        }
        containerClassName="high-light"
        containerStyle={!this.state.focus ? { backgroundColor: "#F5F5F5" } : {}}
        value={this.props.value}
        rows={this.props.rows}
      ></HighlightWithinTextarea>
    );
  }
}

ThemedHighlitedTextarea.contextType = ThemeContext;

export default connect(mapStateToProps)(ThemedHighlitedTextarea);
